import React from 'react'
import { connect } from 'react-redux'
import DeleteAlarmModal from './DeleteAlarmModal'
import { deleteAlarm } from 'UserApp/store/alarm/actions'

function DeleteAlarmModalContainer(props: any) {
  const { alarmId, deleteAlarm, onClose } = props
  console.log(props)
  
  return <DeleteAlarmModal {...props} alarmId={alarmId} onClose={onClose} deleteAlarm={deleteAlarm} />
}
export default connect(
  (state: any) => ({
    isDeleting: state.alarm.isDeleting,
  }),
  (dispatch: any) => ({
    deleteAlarm: (alarmId: string) => dispatch(deleteAlarm(alarmId)),
  })
)(DeleteAlarmModalContainer)

